"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var __1 = tslib_1.__importDefault(require(".."));
var Caption = React.forwardRef(function (_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'figcaption' : _b, children = _a.children, props = tslib_1.__rest(_a, ["as", "children"]);
    return ((0, jsx_runtime_1.jsx)(__1.default, tslib_1.__assign({ as: as, ref: ref, size: 'xxs' }, props, { children: children })));
});
/**
 * @deprecated Use Typography from Antd
 * https://ant.design/components/typography/
 */
exports.default = Caption;
